import React from 'react';
import PropTypes from 'prop-types';
import C from 'classnames';
import format from 'date-fns/format';
import common from 'constants/common';
import ConnectLogo from 'components/atoms/icons/connectLogoIcon';
import DownloadIcon from 'components/atoms/icons/downloadIcon';
import CallSubComment from '../callSubComments';

const CallComment = ({ id, comment, downloadAudio, loading, solid }) => {
  const { createdAt } = comment;
  return (
    <tr className={C({ 'no-strip': solid })}>
      <td className="col-1 text-center">{id}</td>
      <td className="col-8 comment">
        {comment.callComments && comment.callComments.length > 0 && (
          <>
            <strong>Call comments</strong>
            {comment.callComments.map((callComment) => (
              <CallSubComment data={callComment} key={callComment.callId} />
            ))}
          </>
        )}
        <p>Audio</p>

        <span
          className={C('comment-audio-download', { disabled: loading })}
          onClick={() => downloadAudio(comment.message)}
          role="button"
          tabIndex={0}
        >
          <DownloadIcon /> {`${comment.message}.mp3`}
        </span>
        <span>
          Call By: {comment.createdByTitle} {comment.createdByFirstName}{' '}
          {comment.createdByLastName}
          {comment.createdByProfessionType ? ' - ' : ' '}
          {comment.createdByProfessionType}
        </span>
      </td>
      <td className="col-3 info">
        <ConnectLogo />
        <span>
          {createdAt
            ? format(new Date(createdAt), common.dateFormats.dateAndTime)
            : ''}
        </span>
        {comment.commentType && (
          <span
            className="comment-type"
            style={{
              marginBottom: '0px',
              display: 'inline-flex',
              textTransform: 'uppercase',
            }}
          >
            {comment.commentType}
          </span>
        )}
      </td>
    </tr>
  );
};
CallComment.propTypes = {
  comment: PropTypes.shape().isRequired,
  id: PropTypes.number,
  loading: PropTypes.bool.isRequired,
  downloadAudio: PropTypes.func.isRequired,
  solid: PropTypes.bool,
};

export default CallComment;
